export const portfolioFr = {
	portfolio: {
		nav: {
			ariaLabel: 'Navigation principale',
			contact: 'Contact',
			experience: 'Expérience',
			home: 'Accueil',
			projects: 'Projets',
			skills: 'Compétences',
		},
		section: {
			aiIndicator: {
				ariaLabel: 'Développement assisté par IA',
				feature: {
					agents: 'Agents',
					hooks: 'Hooks',
					plans: 'Plans',
					skills: 'Skills',
				},
				info: {
					experience: '5 Ans',
					experienceSubtext: 'Full-stack',
					location: 'Bordeaux, France',
					locationSubtext: 'Télétravail OK',
					role: 'Lead Developer',
					roleSubtext: '@ Orange Business',
				},
				tagline: "J'architecte, l'IA exécute, je valide",
				tech: ['React', 'TypeScript', 'Rust', 'Kubernetes', 'IA', 'Ubuntu'],
				title: 'Programmation collaborative avec Claude Code',
			},
			contact: {
				ariaLabel: 'Contact',
				placeholder: 'Section contact à venir...',
				title: 'Contact',
			},
			experience: {
				ariaLabel: 'Expérience professionnelle',
				badge: {
					leadDev: 'Lead Dev',
				},
				description: {
					liveIntelligence:
						"Développement d'un portail d'administration unifié pour Live Intelligence, la plateforme d'IA générative entreprise d'Orange. Consolidation d'outils fragmentés en une interface de gestion unique et cohérente.",
					packIdApprentice:
						"Programme d'alternance de deux ans, développant des fonctionnalités sur l'ensemble de la stack Pack ID, du mobile Android aux APIs serveur.",
					packIdMigration:
						"Direction de la modernisation technique de Pack ID, un système de badge mobile et de gestion des accès servant plus de 100 000 utilisateurs. Migration d'une infrastructure VM legacy vers une architecture cloud-native.",
				},
				externalLink: 'Voir le produit',
				highlight: {
					liveIntelligence: {
						h1: "Architecture d'un système unifié de gestion des utilisateurs remplaçant plusieurs interfaces d'administration distinctes",
						h2: "Gestion de centaines à milliers d'utilisateurs entreprise sur plusieurs modules",
						h3: 'Évolution vers le rôle de Lead Developer dans une équipe de 10 développeurs',
						h4: 'Livraison de fonctionnalités sur les APIs backend, le frontend web et Keycloak',
						h5: "Création d'un thème Keycloak personnalisé avec Keycloakify pour une expérience d'authentification brandée",
					},
					packIdApprentice: {
						h1: "Développement de pages web, d'APIs REST et d'écrans d'application Android",
						h2: 'Progression de junior à développeur autonome sur le programme de 2 ans',
						h3: "Mentorat de l'apprenti entrant, transfert des connaissances produit",
					},
					packIdMigration: {
						h1: 'Migration de la stack legacy Java/Spring Boot 1 vers Kotlin/Spring Boot 3 moderne sur Azure',
						h2: 'Refactoring vers une architecture stateless avec gestion de session Redis',
						h3: "Accélération des déploiements et amélioration de l'observabilité sur l'ensemble de la stack",
						h4: "Livraison de fonctionnalités sur les APIs backend, le frontend web et l'application mobile",
					},
				},
				period: {
					liveIntelligence: 'Jan 2025 — Présent',
					packIdApprentice: 'Oct 2019 — Nov 2021',
					packIdMigration: 'Déc 2023 — Jan 2025',
				},
				project: {
					liveIntelligence: 'Live Intelligence',
					packId: 'Pack ID',
					packIdMigration: 'Migration Pack ID',
				},
				role: {
					apprentice: 'Développeur Apprenti',
					fullstack: 'Développeur Full-Stack',
				},
				timeline: {
					ariaLabel: "Chronologie de l'expérience",
				},
				title: 'Expérience',
			},
			home: {
				ariaLabel: 'Introduction',
				descriptionEnd: '.',
				descriptionStart:
					"En tant que Lead Developer, je prends les décisions sur l'ensemble de la stack tout en restant profondément investi dans le métier—créer des produits numériques d'exception. Actuellement, je me concentre sur la création de produits IA chez",
				name: 'Thomas GHIZZARDI.',
				tagline: 'Design. Code. Ship.',
			},
			projects: {
				ariaLabel: 'Projets',
				placeholder: 'Section projets à venir...',
				title: 'Projets',
			},
			skills: {
				ariaLabel: 'Compétences et expertise',
				card: {
					code: {
						description:
							'Développer des applications cloud-native et évolutives qui résolvent de vrais problèmes avec du code propre.',
						example1:
							'Concevoir des architectures cloud-ready et container-native',
						example2:
							'Documenter les APIs avec des spécifications OpenAPI claires',
						example3: 'Garantir la qualité avec linters, tests et SonarQube',
						showcaseAlt: "Diagramme d'architecture microservices",
						title: 'Coder avec Intention',
					},
					deploy: {
						description:
							'Déployer de manière sécurisée et portable avec des pipelines automatisés et GitOps.',
						example1: 'Choisir Kubernetes pour la portabilité cloud-agnostique',
						example2:
							'Adopter GitOps pour des déploiements auditables et déclaratifs',
						example3: 'Automatiser les builds, tests et releases via CI/CD',
						showcaseAlt: 'Diagramme de pipeline GitOps',
						title: 'Livrer avec Confiance',
					},
					design: {
						description:
							"Créer des interfaces accessibles et intuitives où l'expérience utilisateur guide chaque décision.",
						example1: "Prototyper les flux utilisateur avant d'écrire du code",
						example2: "Prioriser l'accessibilité et le design inclusif",
						example3:
							'Créer des design systems cohérents avec des tokens clairs',
						showcaseAlt: 'Composants de design system dans Figma',
						title: 'Concevoir avec Soin',
					},
				},
				category: {
					backend: 'Backend',
					deployment: 'Déploiement',
					frontend: 'Frontend',
				},
				technologies: 'Technologies',
				title: {
					v1: 'Compétences',
					v4: 'Compétences',
				},
			},
		},
	},
}
